import { H4 } from "@/lib/styles";
import { smallLabelTypographicStyle } from "@/lib/styles/helpers";
import styled, { css } from "styled-components";
import { CardContainer, ImageContainer } from "../styles";

export const CardContainerPeople = styled(CardContainer)`
  padding: 0;
  gap: 24px;
  background-color: ${({theme})=> theme.colors.white};
`;

export const CardImage = styled.div``;

export const CardInfo = styled.div``;

export const Name = styled(H4)``;

export const Role = styled.p`
  ${smallLabelTypographicStyle}
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.red};
`;

export const Excerpt = styled.p`
  ${smallLabelTypographicStyle}
  margin-top: 16px;
`;

export const ImageContainerPeople = styled(ImageContainer)`
  background-color: lightgray;
  img {
    opacity: 0;
    transition: opacity 0.8s ease-in;

    ${({ $isLoaded }) =>
      $isLoaded &&
      css`
        opacity: 1;
      `}
  }
`;
